import Viewer from './Viewer.jsx';
import './App.css';

function App() {
  return (
    <div className="App">
      <Viewer/>
    </div>
  );
}

export default App;
